var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import axios from "axios";
var casDomain = {
  production: "https://cloudagentsuite.com",
  staging: "https://staging.cloudagentsuite.com",
  development: "http://localhost:3400",
  test: "http://cloudagentsuite.mock"
};
var casQuery = "\n  mutation userProductAvailabilityMutation($user: ExternalUserInputType!) {\n    userProductAvailability(external_user: $user) {\n      id\n      name\n      enable_app_switcher\n      products {\n        id\n        key\n        name\n        tagline\n        switch_route\n        site_license\n        subscribed\n      }\n    }\n  }\n";
export function getConfiguration(_a) {
  var env = _a.env,
      currentApp = _a.currentApp,
      userId = _a.userId,
      userEmail = _a.userEmail,
      casUserId = _a.casUserId,
      casJwt = _a.casJwt,
      mlsCode = _a.mlsCode;
  return __awaiter(this, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , axios({
            method: "post",
            url: casDomain[env] + "/graphql/protected",
            headers: {
              Authorization: "Bearer " + casJwt
            },
            data: {
              query: casQuery,
              operationName: "userProductAvailabilityMutation",
              variables: JSON.stringify({
                user: {
                  application_key: currentApp,
                  id: userId,
                  email: userEmail,
                  cas_user_id: casUserId,
                  mls_code: mlsCode
                }
              })
            }
          })];

        case 1:
          response = _b.sent();
          return [2
          /*return*/
          , response.data.data.userProductAvailability];

        case 2:
          error_1 = _b.sent();
          console.log(error_1);
          return [3
          /*break*/
          , 3];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
}
export function transformConfiguration(_a) {
  var response = _a.response,
      props = _a.props;

  if (!response) {
    return {
      isEnabled: false,
      isCmaAvailable: false,
      isStreamsAvailable: false,
      isMlxAvailable: false,
      isAttractAvailable: false,
      isLaunchpadAvailable: false,
      urlForCma: "",
      urlForStreams: "",
      urlForMlx: "",
      urlForAttract: "",
      urlForLaunchpad: ""
    };
  }

  var links = response.products.reduce(function (state, product) {
    var _a;

    return __assign(__assign({}, state), (_a = {}, _a[product.key] = true, _a[product.key + "_url"] = product.switch_route + "?jwt=" + props.casJwt, _a));
  }, {
    cloud_cma: false,
    cloud_streams: false,
    cloud_mlx: false,
    cloud_attract: false,
    cloud_cma_url: "",
    cloud_streams_url: "",
    cloud_mlx_url: "",
    cloud_attract_url: ""
  });
  return {
    isEnabled: response.enable_app_switcher,
    isCmaAvailable: links.cloud_cma || false,
    isStreamsAvailable: links.cloud_streams || false,
    isMlxAvailable: links.cloud_mlx || false,
    isAttractAvailable: links.cloud_attract || false,
    isLaunchpadAvailable: !!props.casUserId,
    urlForCma: links.cloud_cma_url || "",
    urlForStreams: links.cloud_streams_url || "",
    urlForMlx: links.cloud_mlx_url || "",
    urlForAttract: links.cloud_attract_url || "",
    urlForLaunchpad: casDomain[props.env || "development"] + "/launchpad?jwt=" + props.casJwt
  };
}